import { CSSProperties } from 'react';

interface PropsType {
  style?: CSSProperties;
  color?: string;
}

const SvgIconClose = (props: PropsType) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style ? props.style : undefined}
    >
      <g mask='url(#mask0_1235_3833)'>
        <path
          d='M10.2667 11.0834L11.0834 10.2667L7.81671 7.00008L11.0834 3.73341L10.2667 2.91675L7.00004 6.18341L3.73337 2.91675L2.91671 3.73341L6.18337 7.00008L2.91671 10.2667L3.73337 11.0834L7.00004 7.81675L10.2667 11.0834Z'
          fill={props.color ? props.color : '#E4E4E4'}
        />
      </g>
    </svg>
  );
};

export default SvgIconClose;
